import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import build, { VectorMap } from "react-jvectormap";
import TagsInput from "react-tagsinput";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import ReactDOMServer from 'react-dom/server';

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";
import Slider from "nouislider";
import wNumb from "wnumb";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
moment.locale("es");

var sliders = [];
var initialized_sliders = [];
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class Coverage extends React.Component {
  constructor(props) {
    super(props);
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    this.state = {
      searchQuery: "",
      password: [],
      channels: [
        {
          label: "Móvil",
          value: 1
        },
        {
          label: "Facturación",
          value: 2
        }
      ],
      type: {
        required: "",
        email: "",
        number: "",
        url: "",
        source: "",
        destionation: "",
        requiredState: "",
        emailState: "",
        numberState: "",
        urlState: "",
        equalState: ""
      },
    };

    sliders = [];
    initialized_sliders = [];

    // this.createMobileCards = this.createMobileCards.bind(this);
    this.createConfigurationForm = this.createConfigurationForm.bind(this);
    this.isPasswordReady = this.isPasswordReady.bind(this);
    this.setPassword = this.setPassword.bind(this);
    
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.triggerChange = this.triggerChange.bind(this);
    this.searchCoverage = this.searchCoverage.bind(this);
    this.searchBuildings = this.searchBuildings.bind(this);
    this.getCoverage = this.getCoverage.bind(this);
    this.getBuildingDetailsFound = this.getBuildingDetailsFound.bind(this);
  }
  componentDidMount() {
    // var sliders = [];
    // var slider1 = this.refs.slider1;
    // Slider.create(slider1, {
    //   start: [5],
    //   connect: [true, false],
    //   step: 1,
    //   range: { min: 2, max: 10 },
    //   behaviour: 'tap-drag',
    //   tooltips: true,
    //   format: wNumb({
    //       decimals: 0
    //   }),
    //   animate: true
    // });
    // this.props.get_configuration();
    this.timer = null;
  }
  
  componentDidUpdate(prevProps, prevState) {
  }
  isPasswordReady(id) {
    if (!(id in this.state.password)) return false;
    let result = false;
    let auxPassword = this.state.password;
    let currentPassword = auxPassword[id];
    if (currentPassword.pass1 && currentPassword.pass1.length > 7) {
      if (
        currentPassword.pass2 &&
        currentPassword.pass1 === currentPassword.pass2 &&
        currentPassword.old &&
        currentPassword.old.length > 0
      )
        result = true;
    }

    return result;
  }
  setPassword(id) {
    console.log("setPassword (id): ", id);
    console.log("setPassword (this.state.password): ", this.state.password);
    if (!(id in this.state.password)) return;
    let password = this.state.password[id];
    switch (id) {
      case "password":
        this.props.setPassword({
          password: password.pass1,
          old: password.old
        });
        break;
      default:
        break;
    }
  }
  createConfigurationForm(configuration) {
    let result = null;
    let channelsTest = [
      {
        label: "Móvil",
        value: 84
      },
      {
        label: "Facturación",
        value: 282
      },
      {
        label: "Admin",
        value: 75
      },
      {
        label: "Portabilidad",
        value: 170
      }
    ];

    if (configuration && Object.keys(configuration).length > 0) {
      Object.keys(configuration).map(category => {
        category = configuration[category];
        if (result === null) result = [];
        let tweaks = category.tweaks;
        tweaks = Object.keys(tweaks).map(tweak => {
          tweak = tweaks[tweak];
          let currentTweak = null;
          switch (tweak.input) {
            case "slider":
              sliders[tweak.id] = {
                tweak: tweak,
                ref: React.createRef()
              };
              currentTweak = (
                <div
                  className="slider"
                  style={{ marginTop: "40px" }}
                  ref={el => (sliders[tweak.id].ref = el)}
                />
              );
              break;
            case "tags":
              currentTweak = (
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  isMulti
                  isDisabled={!tweak.editable}
                  closeMenuOnSelect={false}
                  placeholder="Seleccionar canales"
                  name="channels"
                  value={tweak.value.map(tag => {return {label: tag.name, value: tag.id};})}
                  options={channelsTest}
                  noOptionsMessage={() => "Cargando canales"}
                  // onChange={value =>
                  //   this.setState({ channels: value })
                  // }
                />
              );
              break;
            case "password":
              currentTweak = (
                <Row>
                  <Col xs={12} md={3}>
                    <Label>Nueva contraseña</Label>
                    <FormGroup>
                      <Input
                        // disabled={!isAdmin}
                        type="password"
                        // placeholder="12345789"
                        value={
                          tweak.id in this.state.password ? 
                          this.state.password[tweak.id].pass1 : ""}
                        onChange={event => {
                          let newValue = event.target.value;
                          let auxPassword = this.state.password;
                          let auxPasswordLocal = {};
                          if (tweak.id in auxPassword)
                            auxPasswordLocal = auxPassword[tweak.id];
                          auxPasswordLocal.pass1 = newValue;
                          auxPassword[tweak.id] = auxPasswordLocal;
                          this.setState({ password: auxPassword });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} md={3}>
                    <Label>Repetir contraseña</Label>
                    <FormGroup>
                      <Input
                        // disabled={!isAdmin}
                        type="password"
                        // placeholder="12345789"
                        value={
                          tweak.id in this.state.password ? 
                          this.state.password[tweak.id].pass2 : ""}
                        onChange={event => {
                          let newValue = event.target.value;
                          let auxPassword = this.state.password;
                          let auxPasswordLocal = {};
                          if (tweak.id in auxPassword)
                            auxPasswordLocal = auxPassword[tweak.id];
                          auxPasswordLocal.pass2 = newValue;
                          auxPassword[tweak.id] = auxPasswordLocal;
                          this.setState({ password: auxPassword });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} md={3}>
                    <Label>Contraseña actual</Label>
                    <FormGroup>
                      <Input
                        // disabled={!isAdmin}
                        type="password"
                        // placeholder="12345789"
                        value={
                          tweak.id in this.state.password ? 
                          this.state.password[tweak.id].old : ""}
                        onChange={event => {
                          let newValue = event.target.value;
                          let auxPassword = this.state.password;
                          let auxPasswordLocal = {};
                          if (tweak.id in auxPassword)
                            auxPasswordLocal = auxPassword[tweak.id];
                          auxPasswordLocal.old = newValue;
                          auxPassword[tweak.id] = auxPasswordLocal;
                          this.setState({ password: auxPassword });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} md={3}>
                    <Button
                      disabled={!this.isPasswordReady(tweak.id) || this.props.state.isChangingOwnPass}
                      onClick={() => {
                        if (!this.isPasswordReady(tweak.id)) {
                          let options = {
                            place: "tr",
                            message: "¡Vicente, deja de tocar!",
                            type: "error",
                            icon: "now-ui-icons ui-1_check",
                            autoDismiss: 3
                          };
                          if (this.state.debug) this.showNotification(options);
                        } else {
                          this.setPassword(tweak.id);
                        }
                        // console.log("cambiar pulsado", this.props);
                      }}
                      color={
                        this.isPasswordReady(tweak.id) ? "primary" : "default"
                      }
                      style={{ marginTop: "25px" }}
                      leftLabel={"now-ui-icons " + (this.props.state.isChangingOwnPass? "arrows-1_refresh-69 spin" : "objects_key-25")}
                    >
                      {this.props.state.isChangingOwnPass ? "Cambiando" : "Cambiar"}
                    </Button>
                  </Col>
                </Row>
              );
              break;
            default:
              currentTweak = (
                <div>
                  <span>Controlador no encontrado</span>
                  {JSON.stringify(tweak)}
                </div>
              );
              break;
          }
          currentTweak = (
            <Col xs={12} md={tweak.id === "password" ? 12 : 6} key={tweak.id}>
              <CardTitle className="h-nomargin">{tweak.title}</CardTitle>
              <CardCategory className="description">{tweak.description}</CardCategory>
              {currentTweak}
            </Col>
          );
          return currentTweak;
        });
        let iconStyle = {
          marginRight: "10px",
          position: "relative",
          bottom: "-3px"
        };
        let categoryIcon = category.icon ? <i style={iconStyle} className={category.icon} /> : null;
        result.push(
          <Row key={category.id}>
            <Col xs={12}>
              <div className="text-center">
                <CardTitle tag="h4">
                  {categoryIcon}
                  {category.title}
                </CardTitle>
                <CardCategory>{category.description}</CardCategory>
              </div>
            </Col>
            <br />
            {tweaks}
            <br />
          </Row>
        );
      });
    }

    return result;
  }
  handleChange(value) {
    // console.log("handleChange", value);
    clearTimeout(this.timer);

    let state = this.state;
    state.searchQuery = value.target.value;

    this.setState(state);

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  }
  handleKeyDown(e) {
    // console.log("handleKeyDown", e);
    if (e.keyCode === ENTER_KEY) {
      this.triggerChange();
    }
  }
  triggerChange() {
    // console.log("triggerChange", this.state);
    // this.searchCoverage(this.state.searchQuery);
    this.searchBuildings(this.state.searchQuery);
  }
  searchBuildings(value) {
    // console.log("Search buildings:", value);
    this.props.searchBuildings(value);
    this.setState({ selectedBuilding: null });
  }
  searchCoverage(value) {
    // console.log("Search coverage:", value);
    this.props.checkCoverage(value);
  }
  getBuildingDetails(gescal) {
    this.props.getBuildingDetails(gescal);
  }
  getCoverage() {
    if (!this.state.selectedBuildingDetails) {
      return null;
    } else {
      if (this.props.mainState.coverages && (this.state.selectedBuildingDetails.value in this.props.mainState.coverages)) {
        let coverage = this.props.mainState.coverages[this.state.selectedBuildingDetails.value];
        return (
          <Card color="primary" className="text-white text-center">
            <CardBody>
              {coverage}
            </CardBody>
          </Card>
        );
      } else {
        return (
          <Card color="info" className="text-white text-center">
            <CardBody>
              <span>
                <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                Comprobando cobertura
              </span>
            </CardBody>
          </Card>
        );
      }
    }
  }
  getBuildingsFound() {
    // console.log("getBuildingsFound -> this.props.mainState.buildings: ", this.props.mainState.buildings);
    if (this.props.mainState.searchBuildingsQuery) {
      if (this.props.mainState.isSearchingBuildings) {
        return [];
        return (
          <div className="text-center">
            <span>
              <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
              Buscando direcciones con <b>{this.props.mainState.searchBuildingsQuery}</b>...
            </span>
          </div>
        );
      }
      if (this.props.mainState.buildings) {
        if (this.props.mainState.searchBuildingsQuery in this.props.mainState.buildings) {
          let buildings = this.props.mainState.buildings[this.props.mainState.searchBuildingsQuery];
          if (!buildings || buildings.length === 0) 
          return [];
            // return (
            //   <div className="text-center">
            //     <span>
            //       No se encontraron coincidencias para{" "}
            //       <b>{this.props.mainState.searchBuildingsQuery}</b>...
            //     </span>
            //   </div>
            // );
          let buildings_ready = Object.keys(buildings).map(building_id => {
            let current_building = buildings[building_id];
            return {
              label: (
                <span>
                  <i className="now-ui-icons location_pin ticket-state state-abierto" />{" "}
                  {current_building.address}
                </span>
              ),
              value: current_building.gescal
            };
            return (
              <Card className="building-card">
                <CardBody>
              <Col key={current_building.gescal} xs={12} sm={4} md={"auto"}>
                    <Row className="building">
                      <Col className="text-center" xs={12}>
                        <span>
                          <i className="now-ui-icons location_pin ticket-state state-abierto" />{" "}
                          {current_building.address}
                        </span>
                      </Col>
                    </Row>
              </Col>
                  </CardBody>
                </Card>
            );
          });
          return buildings_ready;
          return <Row className="buildings-list">{buildings_ready}</Row>;
        } else {
          return [];
          return (
            <div className="text-center">
              <span>
                <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                Buscando direcciones con <b>{this.props.mainState.searchBuildingsQuery}</b>...
              </span>
            </div>
          );
        }
      }
    } else {
      return [];
      return (
        <div className="text-center">
          <span>
            Realiza una búsqueda, aquí aparecerán los resultados.
          </span>
        </div>
      );
    }
  }
  getBuildingDetailsFound() {
    // console.log("getBuildingDetailsFound -> this.props.mainState.buildingDetails: ", this.props.mainState.buildingDetails);
    if (this.props.mainState.searchBuildingDetailsQuery) {
      if (this.props.mainState.isSearchingBuildingDetails) {
        return [];
      }
      if (this.props.mainState.buildingDetails) {
        if (this.props.mainState.searchBuildingDetailsQuery in this.props.mainState.buildingDetails) {
          let buildingDetails = this.props.mainState.buildingDetails[this.props.mainState.searchBuildingDetailsQuery];
          if (!buildingDetails || buildingDetails.length === 0) 
            return [];
            // return (
            //   <div className="text-center">
            //     <span>
            //       No se encontraron coincidencias para{" "}
            //       <b>{this.props.mainState.searchBuildingsQuery}</b>...
            //     </span>
            //   </div>
            // );
          // console.log("Preparando opciones de puerta: Object.keys(buildingDetails)", Object.keys(buildingDetails));
    
          let buildings_ready = Object.keys(buildingDetails).map(building_id => {
            let current_building = buildingDetails[building_id];
            if (current_building.gescal === null) return null
            return {
              label: (
                <span>
                  <i className="now-ui-icons objects_key-25 ticket-state state-abierto" />{" "}
                  {current_building.summary}
                </span>
              ),
              value: current_building.gescal
            };
          });
          buildings_ready = buildings_ready.filter(el => el !== null);
          return buildings_ready;
        } else {
          return [];
        }
      }
    } else {
      return [];
    }
  }
  customFilter(option, searchText) {
    let label = ReactDOMServer.renderToStaticMarkup(option.label).toLowerCase();
    let result = true;
    let words = searchText.split(" ");
    if (words.length === 0) return false;
    for (let index = 0; index < words.length; index++) {
      const element = words[index];
      element.replace(/\s/g, '');
      if (element && element !== "")
        result = result && label.includes(element.toLowerCase());
    }
    return result;
  }
  render() {
    let channelsTest = [
      {
        label: "Móvil",
        value: 1
      },
      {
        label: "Facturación",
        value: 2
      },
      {
        label: "Admin",
        value: 3
      },
      {
        label: "Portabilidad",
        value: 4
      }
    ];
    return (
      <div id="configuration-page">
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">Cobertura</h2>
              <p className="category">Aquí puedes comprobar la cobertura de fibra óptica y WiFi</p>
            </div>
          }
        />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Form className="form-horizontal" onSubmit={e => { e.preventDefault(); }}>
                <Card>
                  {/* <CardHeader>
                    <CardTitle tag="h4">Type Validation</CardTitle>
                  </CardHeader> */}
                  <CardBody>
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                            <i
                              className={
                                "search-coverage-icon " + 
                                (this.props.mainState.isSearchingBuildings
                                  ? "now-ui-icons arrows-1_refresh-69 spin"
                                  : "now-ui-icons ui-1_zoom-bold")
                              }
                            />
                            <Input
                              type="text"
                              className="search-coverage"
                              placeholder="Escribir dirección..."
                              value={this.state.searchQuery}
                              // onChange={e => this.handleChange("searchQuery", e)}
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              // disabled={this.props.mainState.isSearchingBuildings}
                              // onKeyDown={e => {
                              //   //console.log(e.keyCode);
                              //   if (e.keyCode == 13) {
                              //     console.log("ola k ase?");
                              //     //Enter is key code 13
                              //     // this.searchCustomer();
                              //     // put the login here
                              //   }
                              // }}
                              // style={{ marginRight: "10px" }}
                            />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                  {/* <CardFooter className="text-center">
                    <Button color="primary" onClick={e => this.typeValidate(e)}>
                      Validate Inputs
                    </Button>
                  </CardFooter> */}
                </Card>
              </Form>
            </Col>
          </Row>
          <Row>
            {(this.props.mainState.buildings && Object.keys(this.props.mainState.buildings).length > 0) &&
            this.props.mainState.searchBuildingsQuery in this.props.mainState.buildings && <Col xs={12}>
              <Card>
                <CardBody>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Elige dirección"
                    name="selectedBuilding"
                    value={this.state.selectedBuilding}
                    options={this.getBuildingsFound()}
                    noOptionsMessage={() => this.state.selectedBuilding ? <span>No hay resultados para <b>{this.state.searchBuildings}</b></span> : "Busca una dirección antes"}
                    onChange={value =>{
                      // console.log("######## CAMBIO CLIENTE ######");
                      // console.log(value);
                      this.setState({ selectedBuilding: value, selectedBuildingDetails: null });
                      if (value && value.value) //this.searchCoverage(value.value);
                        this.getBuildingDetails(value.value);
                    }}
                    filterOption={this.customFilter}
                  />
                </CardBody>
              </Card>
            </Col>}
          </Row>
          <Row>
            {this.state.selectedBuilding && (this.props.mainState.buildingDetails && Object.keys(this.props.mainState.buildingDetails).length > 0) &&
            this.props.mainState.searchBuildingDetailsQuery in this.props.mainState.buildingDetails &&
            this.props.mainState.searchBuildingDetailsQuery === this.state.selectedBuilding.value && <Col xs={12}>
              <Card>
                <CardBody>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Elige puerta"
                    name="selectedBuildingDetails"
                    value={this.state.selectedBuildingDetails}
                    options={this.getBuildingDetailsFound()}
                    noOptionsMessage={() => this.state.selectedBuildingDetails ? <span>No hay resultados</span> : "Busca una dirección antes"}
                    onChange={value =>{
                      // console.log("######## CAMBIO CLIENTE ######");
                      // console.log(value);
                      this.setState({ selectedBuildingDetails: value });
                      if (value && value.value) this.searchCoverage(value.value);
                    }}
                    filterOption={this.customFilter}
                  />
                </CardBody>
              </Card>
            </Col>}
            {this.state.selectedBuilding && !(this.props.mainState.buildingDetails && Object.keys(this.props.mainState.buildingDetails).length > 0) && <Col xs={12}>
              <div className="text-center">
                <span>
                  {this.props.mainState.isSearchingBuildingDetails ? <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Buscando puertas del edificio</span> : "Selecciona un edificio, aquí aparecerán las puertas."}
                </span>
              </div>
            </Col>}
            {!(this.props.mainState.buildings && Object.keys(this.props.mainState.buildings).length > 0) && <Col xs={12}>
              <div className="text-center">
                <span>
                  {this.props.mainState.isSearchingBuildings ? <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Buscando direcciones para <b>{this.props.mainState.searchBuildingsQuery}</b></span> : "Realiza una búsqueda, aquí aparecerán los resultados."}
                </span>
              </div>
            </Col>}
          </Row>
          <Row>
            {this.state.selectedBuilding && <Col xs={12}>
              {this.getCoverage()}
            </Col>}
            {!this.state.selectedBuilding && (this.props.mainState.buildings && Object.keys(this.props.mainState.buildings).length > 0) && <Col xs={12}>
              <div className="text-center">
                <span>
                  Selecciona una opción, aquí aparecerá las puertas del edificio.
                </span>
              </div>
            </Col>}
            {!this.state.selectedBuildingDetails && (this.props.mainState.buildingDetails && Object.keys(this.props.mainState.buildingDetails).length > 0) && <Col xs={12}>
              <div className="text-center">
                <span>
                  Selecciona una opción, aquí aparecerá la cobertura.
                </span>
              </div>
            </Col>}
          </Row>
        </div>
      </div>
    );
  }
}

export default Coverage;



// WEBPACK FOOTER //
// ./src/views/Coverage/Coverage.jsx